// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"1fe84b2c691449624605","453":"e108a5dc2441c3a7dedc"}[chunkId] + ".js";
};